import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GET_WLAS_CONFIG } from '@/constants';
import {
  WlasFilters,
  WlasValues,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/utils';
import { WlasApiConfig, fromApiConfig } from '@/features/pages/profile/wlas-widget/wlasConfigApi';

export interface WlasConfigResponse {
  memberUniqueCode: string;
  params: WlasValues;
  filters: WlasFilters;
}

const fetchWlasConfig = (): Promise<WlasConfigResponse> =>
  axios.get<WlasApiConfig>(GET_WLAS_CONFIG).then((res) => fromApiConfig(res.data));

export const WLAS_CONFIG_QUERY_KEY = ['wlas-config'];

export const useGetWlasConfig = (
  options?: Partial<UseQueryOptions<WlasConfigResponse, AxiosError>>,
) =>
  useQuery<WlasConfigResponse, AxiosError>({
    queryKey: WLAS_CONFIG_QUERY_KEY,
    queryFn: fetchWlasConfig,
    ...options,
  });
